export {
  OtpVerificationModal,
  type OtpDescription,
  type OtpVerificationModalProps,
  type OtpVerifyResult,
} from './OtpVerificationModal';
export { useOtpVerificationModal } from './hooks/useOtpVerificationModal';
